import MCIMovers from './MCIMovers';

function App() {
  return <MCIMovers />;
}

export default App;